import { ForwardedRef, useCallback, useImperativeHandle, useState } from 'react';

import { initialState } from '@components/alert/constants';
import { AlertRef, AlertShowParams, AlertState } from '@components/alert/types';

export const useManageAlert = (ref: ForwardedRef<AlertRef>) => {
  const [state, setState] = useState<AlertState>(initialState);

  const show = useCallback(({ title, text, actions, position, boldPrimary, loadingIndicator, titleColor }: AlertShowParams) => {
    setState({
      showAlert: true,
      title,
      titleColor,
      text,
      actions: actions || [],
      position: position || 'horizontal',
      boldPrimary: boldPrimary || false,
      loadingIndicator: loadingIndicator || false,
    });
  }, []);

  const hide = useCallback(() => {
    setState((prev) => ({ ...prev, showAlert: false }));
  }, []);

  useImperativeHandle(ref, () => ({
    show,
    hide,
  }));

  return { state, hide };
};
